import { render, staticRenderFns } from "./HoldTotal.vue?vue&type=template&id=059353c6"
import script from "./HoldTotal.vue?vue&type=script&lang=js"
export * from "./HoldTotal.vue?vue&type=script&lang=js"
import style0 from "./HoldTotal.vue?vue&type=style&index=0&id=059353c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports